<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-info m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <div class="m-b-10">
                <div class="avatar">
                  <!-- <div class="avatar-title rounded-circle fe fe-briefcase"></div> -->
                </div>
              </div>
              <p class="h3 text-dark">{{ filteredClients.length }} Enrollees</p>
            </div>
          </div>
        </div>
      </div>
      <section class="">
        <div class="container">
          <div class="row list">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">Filter Enrollees</div>

                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-4">
                      <label for="inputCity"> Select Sector</label>
                      <select class="form-control" v-model="sector">
                        <option v-for="sector in sectors" :key="sector">
                          {{ sector }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="viewClientsIdCardFilter">Enrollee ID</label>
                      <input id="viewClientsIdCardFilter" type="text" class="form-control" v-model="id_card_number_filter"
                        placeholder="Search by Enrollee ID…" />
                    </div>
                    <div class="form-group col-md-4">
                      <label for="viewClientsPhoneFilter">Phone Number</label>
                      <input id="viewClientsPhoneFilter" type="text" class="form-control" v-model="phone_number_filter"
                        placeholder="Search by Phone Number…" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-5">
                      <button
                        class="btn btn-info btn-block"
                        @click="getClients"
                      >
                        Filter
                      </button>
                    </div>

                    <div class="col-md-5">
                      <button class="btn btn-info btn-block">
                        <download-excel
                          role="button"
                          :header="`Enrollee Data`"
                          :data="filteredClients"
                          :fields="json_fields"
                          type="xls"
                          :escapeCsv="false"
                          name="Facility_Export.xls"
                        >
                          Export to csv <i class="fe fe-download"></i>
                        </download-excel>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table align-td-middle table-card">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>AGENCY Number</th>
                          <th>Phone Number</th>
                          <th>Plan</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="client in filteredClients" v-bind:key="client.id">
                          <td>{{ client.full_name }}</td>
                          <td>{{ client.id_card_number }}</td>
                          <td>{{ client.phone_number }}</td>
                          <td>{{ client.sector }}</td>
                          <td>
                            <router-link :to="{ path: '/client/' + client.id }">
                              <button
                                type="button"
                                name="button"
                                class="btn btn-outline-success"
                              >
                                <i class="fe fe-eye"></i>
                              </button>
                            </router-link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading
                :active.sync="isLoading"
                loader="dots"
                :can-cancel="true"
                :is-full-page="fullPage"
              ></loading>
            </div>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      json_fields: {
        "Full Name": "full_name",
        "AGENCY ID": "id_card_number",
        // NIN: "nimc_number",
        // "User Image": {
        //   field: "user_image",
        //   callback: (value) => {
        //     return `https://claimify-api.hayokmedicare.ng/image/${value}`;
        //   },
        // },
        Sector: "sector",
        // "Vulnerable Group": "category_of_vulnerable_group",
        "Date of Birth": "dob",
        gender: "gender",
        phone_number: "phone_number",
        "Local Govt": "localgovt.local_name",
        Ward: "ward.ward_name",
        // Address: "address1",
        MDA: "place_of_work",
        // "Enrolled By Full Name": "userenrolledby.full_name",
        // "Sector Category(Dependent) ": "user.sector",
        // "MDA (Dependent) ": "user.place_of_work",
        // "Health Facility": "userprovider.agency_name",
      },
      states: "",
      clients: "",
      sectors: "",
      sector: "",
      id_card_number_filter: "",
      phone_number_filter: "",
    };
  },
  computed: {
    filteredClients() {
      const clients = Array.isArray(this.clients) ? this.clients : [];
      const idQuery = this.id_card_number_filter.trim().toLowerCase();
      const phoneQuery = this.phone_number_filter.trim().toLowerCase();
      return clients.filter((client) => {
        const matchesId = !idQuery || String(client.id_card_number || "").toLowerCase().includes(idQuery);
        const matchesPhone = !phoneQuery || String(client.phone_number || "").toLowerCase().includes(phoneQuery);
        return matchesId && matchesPhone;
      });
    },
  },
  beforeMount() {},
  methods: {
    getClients() {
      this.isLoading = true;

      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(
          `/api/v1/auth/getProviderToUser/${
            this.user.type == "provider"
              ? this.user.id
              : this.user.institutional_id
          }`,
          {
            params: {
              sector: this.sector,
            },
          }
        )
        .then((response) => {
          this.clients = response.data;
          this.isLoading = false;

          console.log(response);
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;

        });
    },
    getSectors() {
      this.axios
        .get(`/api/v1/auth/plans-from-users/90`)
        .then((response) => {
          this.sectors = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  created() {
    this.getClients();
    this.getSectors();
  },
};
</script>
